import { Container } from "../../../../components/Container";
import classNames from "classnames/dedupe";
import PabLogo from "../../../../assets/img/partners/PabLogo.svg";
import UkrSibBank from "../../../../assets/img/partners/urkSibBank.svg";
import Vodafone from "../../../../assets/img/partners/vodafone.svg";
import Autotrans from "../../../../assets/img/partners/autotransLogo.svg";
import Konsort from "../../../../assets/img/partners/konsortLogo.svg";
import Ende from "../../../../assets/img/partners/endevourLogo.svg";
import MM from "../../../../assets/img/partners/mm.svg";
import WorldWine from "../../../../assets/img/partners/worldWine.svg";
import Shieds from "../../../../assets/img/shields.svg";
import PoltavskaDumka from "../../../../assets/img/partners/poltavskaDumka.svg";
import GalleryOptima from "../../../../assets/img/partners/galleryOptima.png";
import Yavir from "../../../../assets/img/partners/yavirLogo.svg";
import { Title } from "../../../../components/Title";
import styles from "./Partners.module.sass";

export const Partners = () => {
  const partnersForum = [
    { img: Konsort },
    { img: Autotrans },
    { img: Ende },
    { img: WorldWine },
    { img: PoltavskaDumka },
    { img: Yavir },
    { img: GalleryOptima },
  ];

  const getPartner = (img: string) => (
    <div key={img} className={classNames("df-center", styles.img)}>
      <img className="img" src={img} alt="img: Partner" />
    </div>
  );

  return (
    <div className={styles.rootBg}>
      <Container
        className={classNames("df-center fd-column", styles.container)}
        id="partners"
      >
        <Title text="ПАРТНЕРИ ФОРУМУ" />
        <div className={classNames("df-start fd-column", styles.content)}>
          <div className={classNames("df-start", styles.row)}>
            <div
              className={classNames(
                "df-center fd-column",
                styles.column,
                styles.pab,
              )}
            >
              <p className={styles.subtitle}>ОРГАНіЗАТОР </p>
              <div className={classNames("df-center", styles.img, styles.img1)}>
                <img className="img" src={PabLogo} alt="img: Організатор" />
              </div>
            </div>
            <div className={classNames("df-center fd-column", styles.column)}>
              <p className={styles.subtitle}>головні партнери</p>

              <div className={classNames("df-center")}>
                <div
                  className={classNames("df-center", styles.img, styles.img1)}
                >
                  <img className="img" src={UkrSibBank} alt="img: UkrSibBank" />
                </div>
                <div
                  className={classNames("df-center", styles.img, styles.img1)}
                >
                  <img className="img" src={Vodafone} alt="img: Vodafone" />
                </div>
              </div>
            </div>
            <div className={classNames("df-center fd-column", styles.column)}>
              <p className={styles.subtitle}>інформаційний партнер</p>
              <div className="df-center">
                <div className={classNames("df-center", styles.img)}>
                  <img className="img" src={MM} alt="MIM-Kyiv" />
                </div>
                <div className={classNames("df-center", styles.img)}>
                  <img
                    className="img"
                    src={PoltavskaDumka}
                    alt="Полтавська Думка"
                  />
                </div>
              </div>
            </div>
          </div>
          <hr className={styles.divider} />
          <div className={classNames("df-start fd-column", styles.section)}>
            <p className={classNames(styles.subtitle, styles.textLeft)}>
              партнери форуму
            </p>
            <div className={styles.rowWrapper}>
              <div className={classNames(styles.wrapper, styles.wrapper4)}>
                {partnersForum.map((item) => getPartner(item.img))}
              </div>
              <div className={styles.block}>
                <p className={styles.blockTitle}>
                  Продовжуємо підтримувати{"\n"} Сили оборони україни
                </p>
                <img
                  src={Shieds}
                  alt={"Сили оборони україни"}
                  width={204}
                  height={122}
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <div className={styles.lightDot}></div>
      <div className={styles.darkDot}></div>
    </div>
  );
};
